/*
  useRefreshGridOnVisible
  - Refresca una grid de DevExtreme cuando la pestaña está visible
*/

import { onMounted, onUnmounted, type Ref } from "vue";
import type DxDataGrid from "devextreme-vue/data-grid";

export function useRefreshGridOnVisible(grid: Ref<InstanceType<typeof DxDataGrid>>) {
  
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      grid.value?.instance?.refresh();
    }
  };

  onMounted(() => {
    try {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    } catch {}
  });

  onUnmounted(() => {
    try {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    } catch {}
  });
}